module.exports = __webpack_public_path__ + "static/bottom_mask.9639a5fa.png";